<div class="container">
  <mat-form-field class="search" floatLabel="never" appearance="outline">
    <mat-label>{{ placeholder }}</mat-label>
    <input
      matInput
      (input)="filter()"
      (keydown.enter)="handleClick()"
      [(ngModel)]="searchText"
      [disabled]="statusDisabled"
    />
    <mat-icon matPrefix *ngIf="!actionButton">search</mat-icon>
    <button
      mat-icon-button
      mat-raised-button
      matSuffix
      color="primary"
      *ngIf="actionButton"
      (click)="handleClick()"
      [disabled]="statusDisabled"
    >
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field>
</div>
